export const ADD_MODAL = 'CCYRatesFormModal'
export const ADD_MODAL_OFF_CCY = 'addOfficialCCYModal'
export const ADD_MODAL_COMM_CCY = 'addCommercialCCYModal'
